module.exports = __WEBPACK_EXTERNAL_MODULE_wavesurfer_js__;